import {C_URL} from './config';
import axios from 'axios';
import { Dialog,Toast } from 'vant';
// @ts-ignore
// import AMap from 'AMap';
import router from '@/router';

//请求超时处理
const httpAxios = axios.create();//创建实例
let Config = {
  TIMEOUT: 5000,//设置超时时间为6秒
};
// axios 配置
httpAxios.defaults.timeout = Config.TIMEOUT;
httpAxios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if(error.message.includes('timeout')){   // 判断请求异常信息中是否含有超时timeout字符串
      Toast('请求超时，请稍后再试');
      return Promise.reject(error);          // reject这个错误信息
    }
    Toast('网络连接失败，请稍后再试');
    return Promise.reject(error);
  });

export default {

  getToken() {
    //return "ff38182816d24db1a01f2ce895fe2d9e";
    return localStorage.getItem("token");
  },

  /**
   * 二次封装axios请求方法
   * @param method，请求方式
   * @param url，请求接口地址
   * @param data，请求参数
   * @returns {Promise<object>}
   */
  request(method: string, url: string, data?: any) {
    //alert('token:'+this.getToken());
    return new Promise((resolve, reject) => {
      const options:any = {
        method: method,
        url: `${C_URL}${url}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      };
      if(this.getToken()){
        options.headers.token = this.getToken();
      }
      if(url === "/user/wechatLogin"){
        options.headers.token = localStorage.getItem("firstToken");
      }
      if (method.toLowerCase() === 'get') {
        options.params = data;
      } else {
        options.data = data;
      }
      axios(options).then((res:any) => {
        if (res.data.code == 200) {
          resolve(res.data);
        } else if(res.data.code == 403 || res.data.code == 401) {
          localStorage.removeItem("token");
          router.push("/");
        }else if (res.data.code == 903) {
          resolve(res);
        }else {
          // @ts-ignore
          Dialog.confirm({
            title: '提示',
            message: res.data.message ? res.data.message : '未知错误',
          });
          reject(res.data.message);
        }
      })
      .catch((error:any) => {
          reject(error);
        });
    });
  },


  //获取定位
  // getPosition(){
  //   Toast.loading({
  //     message: '正在获取地址...',
  //     forbidClick: true,
  //   });
  //   return new Promise((resolve,reject)=>{
  //     let map = new AMap.Map('container', {
  //       resizeEnable: true
  //     });
  //     map.plugin('AMap.Geolocation', function() {
  //       let geolocation = new AMap.Geolocation({
  //         // 是否使用高精度定位，默认：true
  //         enableHighAccuracy: true,
  //         // 设置定位超时时间，默认：无穷大
  //         timeout: 10000,
  //       });
  //       map.addControl(geolocation);
  //       geolocation.getCurrentPosition();
  //       AMap.event.addListener(geolocation, 'complete', onComplete);
  //       AMap.event.addListener(geolocation, 'error', onError);

  //       function onComplete(res: any) {
  //         Toast.clear();
  //         resolve(res);
  //       }
  //       function onError(err: any) {
  //         Toast.clear();
  //         reject(err);
  //         Toast.fail("定位失败");
  //         // 定位出错
  //       }
  //     });
  //   });
  // },

  //获取二维码扫码id
  getCodeId(str:string){
    let arr = str.split("?");
    let arr1 = arr[1].split("&");
    let code:string = "";
    arr1.map((item,index)=>{
      if(item.split("=")[0] == 'qrcodeid'){
        code = item.split("=")[1];
      }
    });
    return code;
  },

  //获取剩余天数
  getDateDiff(time:any){
    if(!time){
      return
    }
    let now:any = new Date();
    let yourtime:string = '';
    yourtime = time.replace("-","/");
    let future:any = new Date(yourtime);
    return (future - now)/(1000*3600*24);
  },

  //分割图片
  getBanner(url:string){
    return url.split(",");
  },

  //取时间的前半部分
  getTime(str:string){
    if(str){
      let time = str.split(" ");
      return time[0];
    }else{
      return '';
    }
  },



  /**
   * 清空对象每个属性的值
   * @param obj
   */
  clear(obj:any){
    for(let key in obj){
      obj[key] = "";
    }
  },
  /**
   * objArror对象数组第一个出现属性等于prname的对象索引
   * objArror 也可以使用为对象
   */
  find(objArror:any, prNamn:string, value:any) {
    if (Array.isArray(objArror)) {
      // objArror为数组
      for (let i = 0; i < objArror.length; i++) {
        if (objArror[i][prNamn] == value) {
          return i
        }
      }
    } else {
      // objArror为对象
      for (let x in objArror) {
        if (objArror[x] == value || objArror[x][prNamn] == value) {
          return x
        }
      }
    }
    return -1;
  },

  // 根据文件名后缀区分 文件类型
  /*
   * @param: fileName - 文件名称
   * @param: 数据返回 1) 无后缀匹配 - false
   * @param: 数据返回 2) 匹配图片 - image
   * @param: 数据返回 3) 匹配 txt - txt
   * @param: 数据返回 4) 匹配 excel - excel
   * @param: 数据返回 5) 匹配 word - word
   * @param: 数据返回 6) 匹配 pdf - pdf
   * @param: 数据返回 7) 匹配 ppt - ppt
   * @param: 数据返回 8) 匹配 视频 - video
   * @param: 数据返回 9) 匹配 音频 - radio
   * @param: 数据返回 10) 其他匹配项 - other
   */
  /*matchType(fileName:string) {
    // 后缀获取
    let suffix = '';
    // 获取类型结果
    let result:any = '';
    try {
      let arr = fileName.split('?');
      let flieArr = arr[0].split('.');
      suffix = flieArr[flieArr.length - 1];
    } catch (err) {
      suffix = '';
    }
    // fileName无后缀返回 false
    if (!suffix) {
      result = false;
      return result;
    }
    // 图片格式
    let imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
    // 进行图片匹配
    result = imglist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'image';
      return result;
    };
    // 匹配txt
    let txtlist = ['txt'];
    result = txtlist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'txt';
      return result;
    };
    // 匹配 excel
    let excelist = ['xls', 'xlsx'];
    result = excelist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'excel';
      return result;
    };
    // 匹配 word
    let wordlist = ['doc', 'docx'];
    result = wordlist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'word';
      return result;
    };
    // 匹配 pdf
    let pdflist = ['pdf'];
    result = pdflist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'pdf';
      return result;
    };
    // 匹配 ppt
    let pptlist = ['ppt'];
    result = pptlist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'ppt';
      return result;
    };
    // 匹配 视频
    let videolist = ['mp4', 'm2v', 'mkv'];
    result = videolist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'video';
      return result;
    };
    // 匹配 音频
    let radiolist = ['mp3', 'wav', 'wmv'];
    result = radiolist.some(function (item) {
      return item == suffix;
    });
    if (result) {
      result = 'radio';
      return result;
    }
    // 其他 文件类型
    result = 'other';
    return result;
  }*/
}
